import { useTranslation } from 'react-i18next';
import { DASHBOARD_URL } from '../env';
import TypingTerminal from './TypingTerminal';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      {/* Animated gradient mesh */}
      <div className="pointer-events-none absolute inset-0">
        <div className="mesh-blob absolute -top-40 left-1/4 h-[500px] w-[600px] rounded-full bg-emerald-500/8 blur-3xl" />
        <div className="mesh-blob-delayed absolute -top-20 right-1/4 h-[400px] w-[500px] rounded-full bg-cyan-500/8 blur-3xl" />
        <div className="mesh-blob-slow absolute top-40 left-1/2 h-[350px] w-[450px] -translate-x-1/2 rounded-full bg-amber-500/5 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-4xl px-6 py-24 text-center md:py-32">
        <h1 className="font-display text-4xl font-bold tracking-tight md:text-6xl">
          <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
            {t('hero.titleLine1')}
          </span>
          <br />
          {t('hero.titleLine2')}
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg text-slate-400 md:text-xl">
          {t('hero.description')}
        </p>

        <TypingTerminal />

        <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
          <a
            href={`${DASHBOARD_URL}/register`}
            className="rounded-lg bg-emerald-500 px-6 py-3 text-sm font-medium text-slate-950 hover:bg-emerald-400 transition-colors"
          >
            {t('hero.getStartedFree')}
          </a>
          <a
            href="https://quicktl.dev/cli"
            className="rounded-lg border border-slate-700 px-6 py-3 text-sm font-medium text-slate-300 hover:border-slate-500 hover:text-white transition-colors"
          >
            {t('hero.viewDocs')}
          </a>
        </div>
      </div>
    </section>
  );
}
